export default __webpack_public_path__ + "static/media/step - 12.b2444a96.jpeg";